import { render, staticRenderFns } from "./MileagePriceItem.vue?vue&type=template&id=87c2a496"
import script from "./MileagePriceItem.vue?vue&type=script&lang=js"
export * from "./MileagePriceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports